import { createSlice } from "@reduxjs/toolkit";

let otpFailedAttemptSlice = createSlice({
    name: "otpFailedAttemptAt",
    initialState: null,
    reducers: {
        setOtpFailedAttemptAt: (state, action) => action.payload
    }
});

export const { setOtpFailedAttemptAt } = otpFailedAttemptSlice.actions;
export default otpFailedAttemptSlice.reducer;